
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersNightColour as ObiSnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-night-colour.js';
 
 
 

 
 export const ObiSnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-snow-showers-night-colour',
   elementClass: ObiSnowShowersNightColourElement,
   events: {
     
   }
  });
 
 